import styled from 'styled-components'
import PickupClientSectionUnstyled from './unstyled'

const PickupClientSection = styled(PickupClientSectionUnstyled)`
  background: ${props => props.theme.colors.alabaster};
  padding-bottom: 50px;

  .row {
    padding: 25px 50px;
    background: ${props => props.theme.colors.white};
    box-sizing: border-box;
  }

  .section-title {
    color: ${props => props.theme.colors.primary};
    font-family: ${props => props.theme.fonts.robotoRegular};
  }

  .section-table {
    margin-top: 10px;
    overflow: hidden;
    border-radius: 4px;
    border-collapse: collapse;
    box-shadow: 0 0 2px -1px ${props => props.theme.colors.secondary};

    th {
      padding-top: 30px;

      &:first-child {
        padding-left: 30px;
      }
    }
  }

  .section-footer {
    padding: 25px 50px;
    overflow: hidden;
    background: ${props => props.theme.colors.white};

    label {
      color: ${props => props.theme.colors.regentGray3};
      font-weight: 100;
      display: block;
    }

    .existing-code {
      margin-bottom: 30px;
    }
  }
`
export default PickupClientSection



// WEBPACK FOOTER //
// ./src/Containers/Form/City/Pickup/PickupClientSection/index.js